import { IMAGES } from "./imagesImports";

export const section2Images = [
    {
        src: IMAGES.BIRTH_STAT_1,
        alt: "birth_stat-1",
        text: 'A birth certificate is a foundational document. When you apply for immigration, citizenship, a green card, or certain visas, USCIS requires a certified translation of your birth certificate if the original document is not in English. This ensures USCIS certified acceptance of your records.'
    },
    {
        src: IMAGES.BIRTH_STAT_2,
        alt: "birth_stat-2",
        text: 'Our certified translation services handle your translation from start to finish, with a professional translator verifying the translation to ensure it meets official standards. You’ll receive a word-for-word translation with the certificate of accuracy required for official use.'
    }
];

export const section3Images = [
    {
        src: IMAGES.LANG,
        alt: "birth_language",
        text: 'A full English translation of the original document'
    },
    {
        src: IMAGES.PEN,
        alt: "birth_pen",
        text: 'A signed certificate of translation accuracy'
    },
    {
        src: IMAGES.MEDAL,
        alt: "medal",
        text: 'Translation completed by a certified translator competent to translate the document'
    }
];

export const section4Images = [
    {
        src: IMAGES.WHEELBAG,
        alt: "birth_language",
        text: 'Applying for U.S. immigration or citizenship'
    },
    {
        src: IMAGES.GRADUATED,
        alt: "birth_pen",
        text: 'Enrolling in school or university'
    },
    {
        src: IMAGES.EGG,
        alt: "medal",
        text: 'Getting married in the U.S. and submitting a birth certificate or marriage certificate'
    },
    {
        src: IMAGES.FACESCAN,
        alt: "medal",
        text: 'Handling legal matters that require verification of identity'
    }
];

export const section5Images = [
    {
        src: IMAGES.FLAG_1,
        alt: "spanish_flag",
        text: 'Spanish to English birth certificate translation'
    },
    {
        src: IMAGES.FLAG_2,
        alt: "french_flag",
        text: 'French to English'
    },
    {
        src: IMAGES.FLAG_3,
        alt: "multiple_flags",
        text: 'Arabic, Russian, Chinese, Portuguese, and more'
    }
];

export const section6Images = [
    {
        src: IMAGES.ASSESSMENT_1,
        alt: "birth_assessment_1",
        heading: 'Upload the document',
        description: 'Use our secure platform to upload your original document.',
        backgroundColor : '#F46350'
    },
    {
        src: IMAGES.ASSESSMENT_2,
        alt: "birth_assessment_2",
        heading: 'Quote and turnaround',
        description: 'We’ll assess page count and provide pricing. We charge $24.95 per page.',
        backgroundColor : '#7245ED'
    },
    {
        src: IMAGES.ASSESSMENT_3,
        alt: "birth_assessment_3",
        heading: 'Certified translator assigned',
        description: 'A professional translator starts the project.',
        backgroundColor : '#12ABBF'
    },
    {
        src: IMAGES.ASSESSMENT_4,
        alt: "birth_assessment_4",
        heading: 'Translate your birth certificate',
        description: 'The document is translated word-for-word.',
        backgroundColor : '#F46350'
    },
    {
        src: IMAGES.ASSESSMENT_5,
        alt: "birth_assessment_5",
        heading: 'Certify and deliver',
        description: 'You receive your birth certificate translated and certified, valid for official use.',
        backgroundColor : '#7245ED'
    },
    {
        src: IMAGES.ASSESSMENT_6,
        alt: "birth_assessment_6",
        heading: 'Retrieve translated files',
        description: 'You receive both digital and hard copies if requested.',
        backgroundColor : '#12ABBF'
    }
];

export const section7Images = [
    {
        src: IMAGES.REDPEN,
        alt: "red_pen_image",
        text: 'Signature of the certified translator'
    },
    {
        src: IMAGES.CIRCLESTICKER,
        alt: "circle_sticker_image",
        text: 'Notary seal and stamp'
    },
    {
        src: IMAGES.TICKETTICK,
        alt: "ticket_tick_image",
        text: 'Validation that the translation is complete and accurate'
    }
];

export const section8Images = [
    {
        src: IMAGES.INFORMATION,
        alt: "birth_assessment_1",
        text: 'Format'
    },
    {
        src: IMAGES.LANG_GREEN,
        alt: "birth_assessment_2",
        text: 'Language'
    },
    {
        src: IMAGES.MESSAGEWORD,
        alt: "birth_assessment_3",
        text: 'Certification wording'
    },
    {
        src: IMAGES.ARROWUP,
        alt: "birth_assessment_4",
        text: 'Document submission'
    }
];